// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"7ece6ae7","317":"56a6347a","390":"761250e8","785":"a3bbca01","889":"d3118b48","925":"69a3aaa0"}[chunkId] + ".chunk.css";
};